
import React from 'react'
import { copyInClipboard } from '../../../utility/helpers/copyInClipboard'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CopyInClipcoard = ({ value, label }) => {
    return (
        <FontAwesomeIcon
            onClick={() => copyInClipboard(value, label)} className='cursor-pointer '
            style={{ marginRight: '5px' }}
            icon={faCopy}
            title={`Copiar ${value}`} />

    )
}
